import { useEffect, useState } from "react";
import blogimag from '../Assets/Logo/Blue Logo with BG.png'

const API = "https://growthloomdigital.com/api";

const AdminBlogList = ({ setActive, setEditBlog }) => {
  const [blogs, setBlogs] = useState([]);

  const fetchBlogs = async () => {
    const res = await fetch(`${API}/getBlogs.php`, {
      method: "POST",
    });
    const data = await res.json();
    setBlogs(data.data || []);
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  const handleDelete = async (id) => {
    const formData = new FormData();
    formData.append("id", id);

    await fetch(`${API}/delete.php`, {
      method: "POST",
      body: formData,
    });

    fetchBlogs();
  };

  const handleEdit = (blog) => {
    setEditBlog(blog);
    setActive("add");
  };

  return (
    <div className="bg-white p-6 rounded-xl shadow-md overflow-x-auto">

      <table className="w-full border-collapse">

        {/* HEADER */}
        <thead>
          <tr className="bg-gray-100 text-left text-sm font-semibold text-gray-700">
            <th className="p-3">ID</th>
            <th className="p-3">Date</th>
            <th className="p-3">Title</th>
            <th className="p-3">Content</th>
            <th className="p-3 text-center">Images</th>
            <th className="p-3 text-center">Actions</th>
          </tr>
        </thead>

        {/* BODY */}
        <tbody>
          {blogs.map((blog) => (
            <tr
              key={blog.id}
              className="border-b hover:bg-gray-50 transition"
            >

              {/* ID */}
              <td className="p-3 font-medium">{blog.id}</td>

              {/* DATE */}
              <td className="p-3 text-sm text-gray-600">
                {blog.created_at}
              </td>

              {/* TITLE */}
              <td className="p-3 max-w-[250px] truncate">
                {blog.title}
              </td>

              {/* DATE */}
              <td className="p-3 text-sm text-gray-600">
                {blog.content}
              </td>

              {/* IMAGES */}
              <td className="p-3">
                <div className="flex justify-center gap-2">

                  {blog.image1 && (
                    // <img
                    //   src={blog.image1}
                    //   alt="img1"
                    //   className="w-12 h-12 object-cover rounded border"
                    // />
                    <img
                      // src={
                      //   blog.image1
                      //     ? `https://growthloomdigital.com/uploads/${blog.image1}`
                      //     : blogimag
                      // }
                      src={blog.image1 ? blog.image1 : blogimag}
                      alt="img1"
                      className="w-12 h-12 object-cover rounded border"
                    />
                  )}

                  {blog.image2 && (
                    // <img
                    //   src={blog.image2}
                    //   alt="img2"
                    //   className="w-12 h-12 object-cover rounded border"
                    // />
                    <img
                      src={
                        blog.image2
                          ? `https://growthloomdigital.com/uploads/${blog.image2}`
                          : blogimag
                      }
                      alt="img2"
                      className="w-12 h-12 object-cover rounded border"
                    />
                  )}

                </div>
              </td>

              {/* ACTIONS */}
              <td className="p-3">
                <div className="flex justify-center gap-2">

                  <button
                    onClick={() => handleEdit(blog)}
                    className="bg-yellow-400 hover:bg-yellow-500 text-white px-3 py-1 rounded text-sm"
                  >
                    Edit
                  </button>

                  <button
                    onClick={() => handleDelete(blog.id)}
                    className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded text-sm"
                  >
                    Delete
                  </button>

                </div>
              </td>

            </tr>
          ))}
        </tbody>

      </table>

    </div>
  );
};

export default AdminBlogList;